import URL from "./apiURL";
import api from "../../utils/axiosInstance";
import { getValidToken } from "../../utils/getValidToken";

const errorMessageCreator = (error) => {
    const { data: { message, status } } = error;
    return { status, message };
}

export async function getMMInputDetails(email, type, role, flag, week) {
    try {
        const requestObj = {
            "email": email,
            "type": type,
            "role": role,
            "m_flag": flag,
            'week': week
        };
        const { data } = await api.post(URL.mmInputScreen, requestObj);
        return data;
    } catch (error) {
        const { status, message } = errorMessageCreator(error.response);
        const customError = new Error(message);
        customError.status = status;
        throw customError;
    }
}

export async function get_cbu_line_level_data(username, flag) {
    try {
        const requestObj = { username, m_flag: flag }
        const { data } = await api.post(URL.cbu_line_level_response, requestObj);
        return data;
    } catch (error) {
        const { status, message } = errorMessageCreator(error.response);
        const customError = new Error(message);
        customError.status = status;
        throw customError;
    }
}

export async function get_cbu_level_data(username, flag) {

    try {
        const requestObj = { username, m_flag: flag }
        const { data } = await api.post(URL.cbu_level_response, requestObj);
        return data;
    } catch (error) {
        const { status, message } = errorMessageCreator(error.response);
        const customError = new Error(message);
        customError.status = status;
        throw customError;
    }
}

export async function delete_cbu_line_level_data( payload ) {

    try {
        const requestObj = {...payload};
        const { data } = await api.post(URL.delete_cbu_line_level_response, requestObj);
        return data;
    } catch (error) {
        const { status, message } = errorMessageCreator(error.response);
        const customError = new Error(message);
        customError.status = status;
        throw customError;
    }
}


export async function get_cbu_details(requestObj) {
    try {
        const { data } = await api.post(URL.get_cbu_details, requestObj);
        return data;
    } catch (error) {
        const { status, message } = errorMessageCreator(error.response);
        const customError = new Error(message);
        customError.status = status;
        throw customError;
    }
}


export async function get_cascade_line_list() {
    try {
        const { data } = await api.get(URL.get_cascade_line);
        return data;
    } catch (error) {
        const { status, message } = errorMessageCreator(error.response);
        const customError = new Error(message);
        customError.status = status;
        throw customError;
    }
}


export async function submitMMInputData(table_data, username) {

    try {
        const requestObj = {
            username: username,
            table_data: table_data,
        };
        const { data } = await api.post(URL.submit_mm_input, requestObj);
        return data;
    } catch (error) {
        const { status, message } = errorMessageCreator(error.response);
        const customError = new Error(message);
        customError.status = status;
        throw customError;
    }
}

export async function saveDraftMMInputData(table_data, username) {
    try {
        const requestObj = {
            username: username,
            table_data: table_data,
        };
        const { data } = await api.post(URL.save_draft_mm_input, requestObj);
        return data;
    } catch (error) {
        const { status, message } = errorMessageCreator(error.response);
        const customError = new Error(message);
        customError.status = status;
        throw customError;
    }
}



export async function getDPTableViewDetails(payload) {
    try {
        const { data } = await api.post(URL.tableViewDailyPhasing, payload);
        return data;
    } catch (error) {
        const { status, message } = errorMessageCreator(error.response);
        const customError = new Error(message);
        customError.status = status;
        throw customError;
    }
}

export async function getScheduleViewDailyPhasingDetails(email, type, role) {
    try {
        const requestObj = {
            "email": email,
            "type": type,
            "role": role
        };
        const { data } = await api.post(URL.scheduleViewDailyPhasing, requestObj);
        return data;
    } catch (error) {
        const { status, message } = errorMessageCreator(error.response);
        const customError = new Error(message);
        customError.status = status;
        throw customError;
    }
}

// api call function for filter & week filter data in Plan vs actuals Page
export async function getPlanWeekFilterDetails(payload) {
    try {
        const token = await getValidToken();

        const r = await fetch(`${URL.aggregate_plan_actual}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
            },
            body: JSON.stringify(payload)
        });
        if (!r.ok) throw new Error(`Error: ${r.status} ${r.statusText}`);
        return await r.json();
    } catch (error) {
        const { status, message } = errorMessageCreator(error.response);
        const customError = new Error(message);
        customError.status = status;
        throw customError;
    }
}

// api call function for export to excel in Plan vs actuals Page
export async function getValidatedNewCBUFromExcel(payload) {
    try {
        const token = await getValidToken();
        const response = await fetch(`${URL.validateNewCBUFromExcel}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
            },
            body: JSON.stringify(payload)
        });

        const responseDataText = await response.json();
        return responseDataText;
    } catch (error) {
        const { status, message } = errorMessageCreator(error.response);
        const customError = new Error(message);
        customError.status = status;
        throw customError;
    }
};

export async function getAeraPlanThursdayPlan() {
    try {
        const token = await getValidToken();
        const response = await fetch(`${URL.fetchAeraPlanData}`, {
            method: "GET",
            headers: {
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
            }
        });

        const responseDataText = await response.json();
        return responseDataText;
    } catch (error) {
        const { status, message } = errorMessageCreator(error.response);
        const customError = new Error(message);
        customError.status = status;
        throw customError;
    }
}

export async function getOverloadedData(payload) {
    try {
        const token = await getValidToken();
        const response = await fetch(`${URL.fetchOverloadedData}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
            },
            body: JSON.stringify(payload)
        });

        const responseDataText = await response.json();
        return responseDataText;
    } catch (error) {
        const { status, message } = errorMessageCreator(error.response);
        const customError = new Error(message);
        customError.status = status;
        throw customError;
    }
};

export async function getTonsPerShift(payload) {
    try {
        const token = await getValidToken();
        const response = await fetch(`${URL.getTonsPerShift}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
            },
            body: JSON.stringify(payload)
        });

        const responseDataText = await response.json();
        return responseDataText;
    } catch (error) {
        const { status, message } = errorMessageCreator(error.response);
        const customError = new Error(message);
        customError.status = status;
        throw customError;
    }
};

export async function handleTrackingUpdate(payload) {
    const table_data = [...payload];
    try {
        const token = await getValidToken();
        await fetch(`${URL.handleTrackingUpdate}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
            },
            body: JSON.stringify(table_data)
        });

    } catch (error) {
        const { status, message } = errorMessageCreator(error.response);
        const customError = new Error(message);
        customError.status = status;
        throw customError;
    }
};


